import axios from 'axios'
let urlParams = new URLSearchParams (window.location.search)
let cat = urlParams.has('cat') ? '/'+urlParams.get('cat') : ''
let baseUrl = `https://www.bayern1.radio/pdd/quizzes${cat}`


const getCurrentQuiz = async () => {
  try {
    // let response = await axios.get\('https://www.bayern1.radio/pdd/quizzes/current')
    let response = await axios.get(`${baseUrl}/current`)
    return response.data
  } catch (error) {
    console.error("ERROR", error) 
    return null
  }
}

const getRandomPastQuiz = async () => {
  try {
    // let response = await axios.get('https://www.bayern1.radio/pdd/quizzes/random')
    let response = await axios.get(`${baseUrl}/random`)
    return response.data
  } catch (error) {
    console.error("ERROR", error) 
    return null
  }
}

export {
  getCurrentQuiz, getRandomPastQuiz
} 